{
  "id": "campaign-124",
  "name": "Neglected Field III",
  "seed": "campaign:124",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r,,,,QQQQ,,,,r",
    ",,:,,,...,,:,,",
    ",,:..a..a,x:..",
    "..::::::::::,,",
    "......x,,,,,,,",
    "..a..a,,a,,a,,",
    ".a..a,,,,a,,a,",
    "::::::::::::::",
    ",,,,a,,,,a,,,,",
    ",,,a,,,x,,a,,,",
    ",,,,,a,,a,,,,,",
    ",,::::::::::,,",
    ",#:,,,,,,,x:,,",
    "..:,,,,,,,,:..",
    "....,QQQQ,...S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 11,
      "y": 2
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 2
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 7
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 11
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 11
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 10,
      "y": 1
    },
    {
      "kind": "gas",
      "x": 12,
      "y": 11
    },
    {
      "kind": "gas",
      "x": 6,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 14
    },
    {
      "kind": "rare",
      "x": 1,
      "y": 0
    },
    {
      "kind": "repair",
      "x": 0,
      "y": 14
    }
  ],
  "generatorVersion": 3,
  "level": 124,
  "biome": "stadium",
  "par": {
    "reel": 7348,
    "push": 6245,
    "selfPropelled": 6054,
    "tractor": 5025,
    "zeroTurn": 4126,
    "fairway": 2400
  },
  "goldTime": {
    "reel": 7348,
    "push": 6245,
    "selfPropelled": 5718,
    "tractor": 4885,
    "zeroTurn": 4126,
    "fairway": 2374
  },
  "routeTries": {
    "par": {
      "reel": 5,
      "push": 2,
      "selfPropelled": 0,
      "tractor": 6,
      "zeroTurn": 4,
      "fairway": 22
    },
    "gold": {
      "reel": 5,
      "push": 2,
      "selfPropelled": 36,
      "tractor": 44,
      "zeroTurn": 4,
      "fairway": 49
    }
  }
}
